import { createBlock } from './block';
import { Block, } from '@chameleoncreator/creator-app';

export interface SCORMProps {
  shouldSendScoreWhen: string
  moduleCompleteInterationRequirement: string
  moduleCompleteScoreRequirement: boolean
  scormExitMessage: string
  scormExitDelay: boolean
  scormControlledExit: boolean
}

export const createScorm = (props: SCORMProps = {
  scormExitMessage: 'logout',
  shouldSendScoreWhen: "NEVER",
  moduleCompleteInterationRequirement: "allInteractionsSeen",
  moduleCompleteScoreRequirement: false,
  scormControlledExit: false,
  scormExitDelay: false,
}): Block => {
  return createBlock(
    'SCORM',
    [],
    {
      props: {
        shouldSendScoreWhen: props.shouldSendScoreWhen,
        moduleCompleteInterationRequirement: props.moduleCompleteInterationRequirement,
        moduleCompleteScoreRequirement: props.moduleCompleteScoreRequirement,
        scormControlledExit: props.scormControlledExit,
        scormExitDelay: props.scormExitDelay,
        scormExitMessage: props.scormExitMessage
      },
    }
  );
};